import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#1677ff',
  layout: 'mix',
  splitMenus: true,
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: 'AI清关工作台',
  pwa: true,
  logo: '/logo.svg',
  iconfontUrl: '',
  token: {
    bgLayout: '#f5f8ff',
  },
};

export default Settings;
